var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationObserver',{ref:"observer"},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',[_c('validation-provider',{attrs:{"rules":_vm.validateRules},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('v-text-field',{class:{
            'hide-underline': true,
            'cursor-style': _vm.isEdit === false ? true : false,
            'ma-0': true,
          },attrs:{"error-messages":errors,"hide-details":"auto","dense":"","readonly":!_vm.isEdit,"placeholder":_vm.placeholder},on:{"input":function($event){return _vm.$emit('input', _vm.textValue)}},model:{value:(_vm.textValue),callback:function ($$v) {_vm.textValue=$$v},expression:"textValue"}})]}}])})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }